{
    "onthejobtraining": {
        "Baslik": "On The Job Training",
        "Kullanici": "User",
        "Musteri": "Customer",
        "Tarih": "Date",
        "Durum": "Status",
        "Gorus": "Opinion",
        "Not": "Note",
        "Degerlendirme": "Evaluation",
        "RandevuDetayi": "Appointment Detail",
        "RandevuTarihi": "Appointment Date",
        "RandevuSonucu": "Appointment Result",
        "Arama": "Search",
        "Ara": "Search",
        "Kapat": "Close",
        "Temizle": "Clear",
        "Kaydet": "Save",
        "KaydetKapat": "Save-Close",
        "Bekliyor": "Waiting for Opinion",
        "GorusAldi": "Answer Written",
        "Tamamlandi": "Closed",
        "EminMisiniz": "Are you sure?",
        "SilmeMesaj": "You cannot undo this!",
        "Hepsi": "All"
    }
}
